import React, { createContext, useContext, useState } from "react";
import LoadingCard from "../../utils/LoadingCard";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = () => setIsLoading(true);
  const hideLoading = () => setIsLoading(false);

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
      {children}
      {isLoading && <LoadingCard />} {/* Render LoadingCard conditionally */}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
